module.exports = "<vb-content-page-view>\r\n\r\n  <div page-title>Benutzerverwaltung</div>\r\n\r\n  <div page-content>\r\n\r\n  </div>\r\n\r\n</vb-content-page-view>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/crm/views/user-view/user-view.component.html
// module id = ./src/app/crm/views/user-view/user-view.component.html
// module chunks = main